export const defaultActiveMenuStyles = {
  shaped: false,
  rounded: false,
  flat: false,
};

export default {
  show: true,
  miniVariant: true,
  isRight: false,
  activeMenuStyle: {
    shaped: true,
    rounded: false,
    flat: false,
  },
  dense: true,
};
